import React, { FC } from 'react';
import { CURRENCIES, Currency } from './Currencies';

export const CurrencySign: FC<{ currency: Currency }> = ({
  currency = 'USD',
}) => <span>{CURRENCIES[currency].symbol}</span>;
